<template>
  <t-default-entry
    heading="ログインできない・ID、パスワードを忘れた"
    :navigation-items="navigationItems"
    :class="componentClassName"
  >
    <div class="t-can-not-login__main">
      <!-- 契約ID忘れた場合 -->
      <div class="t-can-not-login__scope">
        <div class="m-heading">
          <span>■ 契約IDが分からない方</span>
        </div>
        <div class="m-content-info">
          <a-text>
            <a-button variant="text" color="primary" :inline="true" @click="gotoForgotID">こちら</a-button>
            <span>より契約IDの再通知申請をお願いします。</span>
            <p>　※ユーザーIDが必要です</p>
          </a-text>
        </div>
      </div>
      <!-- パスワード忘れた場合 -->
      <div class="t-can-not-login__scope">
        <div class="m-heading">
          <span>■ パスワードが分からない方</span>
        </div>
        <div class="m-content-info">
          <a-text>
            <a-button variant="text" color="primary" :inline="true" @click="gotoResetPassword">こちら</a-button>
            <span>よりパスワードリセットをお願いします。</span>
            <p>　※契約IDおよびユーザーIDが必要です。</p>
          </a-text>
        </div>
      </div>
      <!-- ユーザーID忘れた場合 -->
      <div class="t-can-not-login__scope">
        <div class="m-heading">
          <span>■ ユーザーIDが分からない方</span>
        </div>
        <div class="m-content-info">
          <a-text>・契約者権限ユーザーの方</a-text>
          <a-text>お申し込み時に入力いただいたメールアドレスをご入力ください。</a-text>
          <a-text>・契約者権限ユーザー以外の方</a-text>
          <a-text>管理者の方にお問い合わせください。</a-text>
        </div>
      </div>
      <!-- 初期ログインできない場合 -->
      <div class="t-can-not-login__scope">
        <div class="m-heading">
          <span>■ COTOHA Call Centerからのメールが見つからず、初回ログインができない方</span>
        </div>
        <div class="m-content-info">
          <a-text>どうしてもメールが見つからない場合、以下の手順でログインをお願いします。</a-text>
          <a-text>1.「■契約IDが分からない方」の通り、契約IDの再通知申請を行う。</a-text>
          <a-text>2.「■パスワードが分からない方」の通り、パスワードリセットを行う。</a-text>
          <a-text>3.以下のメールが送信されますので、メールに従いログインをお願いします。</a-text>
          <a-text>　</a-text>
          <a-text>
            送信元メールアドレス：
            <a href="mailto:noreply-cotohacc@vdxp-sys.com">noreply-cotohacc@vdxp-sys.com</a>
          </a-text>
          <a-text>件名：【COTOHA Call Center】パスワードリセットのお知らせ</a-text>
        </div>
      </div>
    </div>
  </t-default-entry>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AText from '@/components/atoms/text';
import AButton from '@/components/atoms/button';

export default {
  name: 't-can-not-login',
  components: {
    AText,
    AButton,
  },
  mixins: [],
  props: {
    class: {
      type: String,
      default: '',
    },
    navigationItems: {
      type: Array,
      default: new Array(0),
    },
  },
  data: function () {
    return {};
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-can-not-login');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    gotoLogin() {
      this.$router.push({ name: 'login' });
    },
    gotoForgotID() {
      this.$router.push({ name: 'ForgotID' });
    },
    gotoResetPassword() {
      this.$router.push({ name: 'SelfResetPassword' });
    },
  },
};
</script>
